import { inject } from '@angular/core';
import { CanActivateChildFn, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { WINDOW } from '@ng-web-apis/common';

import { handleNavigationCanActivateUseCase } from './handle-navigation-can-activate.use-case';

import { CommonWindow } from '@core/domain/models/common-window.model';

export const canActivateChildLayout: CanActivateChildFn = (
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
    router: Router = inject(Router),
    window: CommonWindow = inject(WINDOW) as CommonWindow,
) => {
    const itx = window?.inditex;
    const typeErrorJava = itx?.is410Error ? '/error/no-stock' : '/error';
    // TODO ECOMDUTI-27196 Esta pagina debe soportar una carga por SSR si quiere ejecutarse en paginas donde esté activo (Parrillas, Fichas de producto, Homes ...)
    const page = itx?.isNode ? '/error-ssr' : typeErrorJava;

    if (itx?.is410Error || itx?.is404Error) {
        // eslint-disable-next-line no-param-reassign
        window.inditex.is410Error = false;
        // eslint-disable-next-line no-param-reassign
        window.inditex.is404Error = false;
        return handleNavigationCanActivateUseCase(page, route.params, router);
    }

    return true;
};
